<template>
  <div :class="$style.ctn">
    <template v-for="(familyMalConf, index) in familiesMalconfs" :key="index">
      <h3 :class="$style.familyName">
        {{ familyMalConf.family }}
      </h3>

      <div
        v-for="(processesMalConf, index) in familyMalConf.processesMalconfs"
        :key="index"
        :class="$style.table"
      >
        <TableViewerLine
          :is-head="true"
          name="(PID) Process"
          :value="pidProcess(processesMalConf.process)"
        />

        <template v-for="malconf in processesMalConf.malconfs">
          <TableViewer :data="malconf.config" />
        </template>
      </div>
    </template>
    <div :class="[com.message, $style.noData]">
      No Malware configuration.
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import Badge from './Badge.vue';
import PaginationTable from './PaginationTable.vue';
import Stats from './Stats.vue';
import TipMessage from './TipMessage.vue';
import ValueCell from './ValueCell.vue';
import TableViewer from './TableViewer.vue';
import TableViewerLine from './TableViewerLine.vue';

export default defineComponent({
  components: {
    Stats,
    PaginationTable,
    TipMessage,
    Badge,
    ValueCell,
    TableViewer,
    TableViewerLine,
  },
  inject: ['root'],
  data() {
    return {};
  },
  computed: {
    familiesMalconfs() {
      return this.root.malwareConfiguration.familiesMalconfs;
    },
  },
  methods: {
    pidProcess(process) {
      if (!process) {
        return 'unknown';
      }
      return `(${process.pid}) ${process.fileName}`;
    },
  },
});
</script>
<style lang="scss" module>
.ctn {
  padding-top: 20px;
}
.table {
  & + .table {
    margin-top: 20px;
  }
  & + .familyName {
    margin-top: 20px;
  }

  & + .noData {
    display: none;
  }

  @media screen and (max-width: 700px) {
    overflow-y: hidden;
    overflow-x: auto;
    
    > * {
      width: 600px;
    }
  }
}

.familyName {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;

  color: #575757;
  & + .table {
    margin-top: 10px;
  }
}
</style>

<style lang="scss" src="./common.module.scss" module="com"></style>
